import { useDocumentTitle } from '@/lib/useDocumentTitle'
import type { ReactNode } from 'react'
import flameWhite from '@/assets/brand/favicon_white.png'

interface PageHeaderProps {
  /** Page title, rendered in the heading font. */
  title: string
  /** Short descriptive subtitle shown under the title. */
  subtitle?: ReactNode
  /** Optional right-aligned action slot (e.g. a search box or buttons). */
  actions?: ReactNode
}

/**
 * Shared pre-invest page header: a glass card (schets `.vonk-header__inner`)
 * with a flame accent mark, an ink-on-white title + muted subtitle, an optional
 * right-aligned actions slot, and a brand accent bar along the bottom edge.
 */
export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  useDocumentTitle([title])
  return (
    <header className="vonk-pagehead">
      <div className="flex min-w-0 items-center gap-3.5">
        <span className="vonk-pagehead__mark" aria-hidden>
          <img src={flameWhite} alt="" className="size-5 object-contain" />
        </span>
        <div className="flex min-w-0 flex-col gap-0.5">
          <h1 className="font-heading text-2xl font-bold text-foreground">{title}</h1>
          {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
        </div>
      </div>
      {actions ? (
        <div className="flex shrink-0 items-center gap-2 max-md:w-full max-md:flex-wrap">
          {actions}
        </div>
      ) : null}
      <div className="vonk-accent-bar absolute inset-x-0 bottom-0 rounded-none" />
    </header>
  )
}
